import { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const accountPopover: SxStyle = {
  width: 300,
  px: 0,
  py: 0,
  mt: 0.5,
  backgroundImage: 'none',
  backgroundColor: (p) => p.palette.background.paper,
  border: '1px solid',
  borderColor: (p) => p.palette.primary[500],
};

export const actions: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  borderColor: (theme) =>
    theme.palette.grey[theme.palette.mode === 'dark' ? 800 : 700],
  backgroundColor: (theme) =>
    theme.palette.grey[theme.palette.mode === 'dark' ? 800 : 200],
  borderBottom: 'solid 1px',
  borderBottomColor: (theme) =>
    theme.palette.grey[theme.palette.mode === 'dark' ? 700 : 400],
};

export const title: SxStyleFunc = (isOpen: boolean) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: isOpen ? 'space-between' : 'center',
  padding: (p) => p.spacing(0.75, 1),
  borderBottom: '1px solid',
  borderColor: (p) => p.palette.grey[400],
  alignItems: 'center',
});

export const navWrapper: SxStyleFunc = ({
  setting,
  sx,
}: {
  setting: any;
  sx?: SxStyle;
}) => ({
  display: 'flex',
  justifyContent: setting.title ? 'space-between' : 'center',
  alignItems: 'center',
  // borderBottom: (theme) =>
  //   `1px solid ${
  //     theme.palette.grey[theme.palette.mode === 'dark' ? 700 : 300]
  //   }`,
  borderTop: (theme) => `1px solid ${theme.palette.grey[300]}`,
  ...sx,
});

export const content: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  flex: '0 0 100%',
};

export const avatarBox: SxStyleFunc = (isOpen: boolean) => ({
  cursor: 'pointer',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: isOpen
    ? (p) => p.palette.primary[500]
    : (p) => p.palette.grey[300],
  borderRadius: (p) => p.spacing(0.5),
  height: (p) => p.spacing(3.5),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'row',
  pl: 0.5,
});

export const popupIcon: SxStyle = {
  color: (p) => p.palette.grey[700],
};

export const popoverContent: SxStyle = {
  p: 0,
  maxHeight: '100vh',
};

export const avatarImage: SxStyle = {
  width: 22,
  height: 22,
};

export const popoverTitle: SxStyle = {
  border: 0,
  borderColor: 'divider',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  padding: (p) => p.spacing(1, 1.5, 1.25, 1.5),
  gap: 0,
};

export const userName: SxStyle = {
  fontSize: (p) => p.typography.body3.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
  color: (p) => p.palette.grey[700],
  width: 1,
};

export const creditBox: SxStyle = {
  px: (p) => p.spacing(1.5),
  gap: (p) => p.spacing(1.25),
  width: '100%',
};
